import { tss } from 'tss-react';
import { Theme } from '@mui/material/styles';

export const useStyles = tss
  .withParams<{ theme: Theme }>()
  .create(({ theme }) => ({
    filterTitle: {
      fontSize: '16px',
      fontWeight: 700,
      width: '100px',
      [theme.breakpoints.down('sm')]: {
        marginBottom: '10px',
      },
    },
    tabWrapper: {
      width: '100%',
      [theme.breakpoints.down('md')]: {
        overflowX: 'auto',
        width: '280px',
      },
    },
    menu: {
      height: 300,
      width: 150,
    },
  }));
